import React, { useState, useLayoutEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import { registerUser } from '../utils/apiService';
const Register = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: ''
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');


    useLayoutEffect(() => {
        const timer = setTimeout(() => {
            if (window.animationText) window.animationText();
            if (window.scrollingEffect) window.scrollingEffect();
            if (window.animateImgItem) window.animateImgItem();

            if (window.ScrollTrigger) {
                window.ScrollTrigger.refresh();
            }
        }, 100);

        return () => {
            clearTimeout(timer);
            if (window.revertAnimations) window.revertAnimations();
            if (window.revertHeadline) window.revertHeadline();
        };
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error for this field when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
         if (successMessage) {
            setSuccessMessage('');
        }
    };

    const togglePassword = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const validateForm = () => {
        const newErrors = {};

        // First Name validation
        if (!formData.firstName.trim()) {
            newErrors.firstName = 'First name is required';
        } else if (formData.firstName.trim().length < 2) {
            newErrors.firstName = 'First name must be at least 2 characters';
        }

        // Last Name validation
        if (!formData.lastName.trim()) {
            newErrors.lastName = 'Last name is required';
        } else if (formData.lastName.trim().length < 2) {
            newErrors.lastName = 'Last name must be at least 2 characters';
        }

        // Email validation
        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email is invalid';
        }

        // Phone validation
        if (!formData.phone) {
            newErrors.phone = 'Phone number is required';
        } else if (!/^\d{10}$/.test(formData.phone.replace(/\s/g, ''))) {
            newErrors.phone = 'Phone number must be 10 digits';
        }

        // Password validation
        if (!formData.password) {
            newErrors.password = 'Password is required';
        } else if (formData.password.length < 8) {
            newErrors.password = 'Password must be at least 8 characters';
        } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(formData.password)) {
            newErrors.password = 'Password must contain uppercase, lowercase, and number';
        }

        // Confirm Password validation
        if (!formData.confirmPassword) {
            newErrors.confirmPassword = 'Please confirm your password';
        } else if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);
          setErrors({});
                setSuccessMessage('');
        
                try {
                    const response = await registerUser(formData);
        
                    if (response.status) {
                        // Registration successful
                        setSuccessMessage(response.message || 'Registration successful!');
                        
                        // Store user data if provided
                        if (response.data) {
                            // You can store token or user data here
                            // localStorage.setItem('token', response.data.token);
                            // localStorage.setItem('user', JSON.stringify(response.data.user));
                        }
                        // Clear form
                        setFormData({
                            firstName: '',
                            lastName: '',
                            email: '',
                            phone: '',
                            password: '',
                            confirmPassword: ''
                        });
        
                        // Redirect to login page after 2 seconds
                        setTimeout(() => {
                            navigate('/login');
                        }, 2000);
                    } else {
                        // Handle backend validation errors
                        if (response.errors && Object.keys(response.errors).length > 0) {
                            // Map backend field names to frontend field names
                            const mappedErrors = {};
                            Object.keys(response.errors).forEach(key => {
                                const frontendKey = key
                                    .replace('first_name', 'firstName')
                                    .replace('last_name', 'lastName')
                                    .replace('password_confirmation', 'confirmPassword');
                                
                                // Take the first error message if it's an array
                                mappedErrors[frontendKey] = Array.isArray(response.errors[key])
                                    ? response.errors[key][0]
                                    : response.errors[key];
                            });
                            setErrors(mappedErrors);
                        } else {
                            // General error message
                            setErrors({
                                submit: response.message || 'Registration failed. Please try again.'
                            });
                        }
                    }
                } catch (error) {
                    console.error('Registration error:', error);
                    setErrors({
                        submit: 'An unexpected error occurred. Please try again later.'
                    });
                } finally {
                    setIsSubmitting(false);
            }
       
    };

    return (
        <div className="wrapper position-relative">
            <Header />

            {/* Background Masks */}
            <div className="wrapper position-relative overflow-x-clip">
                <div className="mask mask-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                        <circle cx="400" cy="400" r="325" stroke="url(#a6)" strokeWidth="150" />
                        <defs>
                            <linearGradient id="a6" x1="176" x2="569" y1="70.5" y2="674">
                                <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                                <stop offset="1" stopColor="#fff" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <div className="mask mask-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                        <circle cx="400" cy="400" r="325" stroke="url(#e7)" strokeWidth="150" />
                        <defs>
                            <linearGradient id="e7" x1="176" x2="569" y1="70.5" y2="674">
                                <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                                <stop offset="1" stopColor="#fff" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
            </div>

            {/* Page Title */}
            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1 className="title">
                            <span className="split-text effect-right">Create Account</span>
                        </h1>
                        <div className="breadkcum">
                            <Link to="/" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right">Home</span>
                            </Link>
                            <span className="dot"></span>
                            <span className="page-breadkcum body-2 fw-7">
                                <span className="split-text effect-right">Register</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="main-content">
                <section className="section-contact p-contact tf-spacing-2">
                    <div className="tf-container">
                        <div className="row justify-content-md-center">
                            <div className="col-lg-6">
                                <div className="section-contact-inner flex justify-content-between flex-wrap login-form">
                                    <form 
                                        id="registerform" 
                                        className="form-contact-us style-bg-dark-2 px-md-15" 
                                        onSubmit={handleSubmit}
                                    >
                                       {successMessage && (
                                            <div className="alert alert-success mb-37" role="alert">
                                                {successMessage}
                                            </div>
                                        )}

                                        {/* Submit Error */}
                                        {errors.submit && (
                                            <div className="alert alert-danger mb-37" role="alert">
                                                {errors.submit}
                                            </div>
                                        )}
                                        {/* First Name & Last Name */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="icon-user"></i>
                                                    <input 
                                                        type="text" 
                                                        name="firstName" 
                                                        id="firstName" 
                                                        placeholder="First Name"
                                                        value={formData.firstName}
                                                        onChange={handleChange}
                                                        className={errors.firstName ? 'error' : ''}
                                                        disabled={isSubmitting}
                                                    />
                                                    {errors.firstName && (
                                                        <span className="error-message text-danger small d-block mt-1">
                                                            {errors.firstName}
                                                        </span>
                                                    )}
                                                </fieldset>
                                            </fieldset>

                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="icon-user"></i>
                                                    <input 
                                                        type="text" 
                                                        name="lastName" 
                                                        id="lastName" 
                                                        placeholder="Last Name"
                                                        value={formData.lastName}
                                                        onChange={handleChange}
                                                        className={errors.lastName ? 'error' : ''}
                                                         disabled={isSubmitting}
                                                    />
                                                    {errors.lastName && (
                                                        <span className="error-message text-danger small d-block mt-1">
                                                            {errors.lastName}
                                                        </span>
                                                    )}
                                                </fieldset>
                                            </fieldset>
                                        </div>

                                        {/* Email Field */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="icon-email"></i>
                                                    <input 
                                                        type="email" 
                                                        name="email" 
                                                        id="email" 
                                                        placeholder="Email Address"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        className={errors.email ? 'error' : ''}
                                                         disabled={isSubmitting}
                                                    />
                                                    {errors.email && (
                                                        <span className="error-message text-danger small d-block mt-1">
                                                            {errors.email}
                                                        </span>
                                                    )}
                                                </fieldset>
                                            </fieldset>
                                        </div>

                                        {/* Phone Field */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <i className="icon-phone"></i>
                                                    <input 
                                                        type="tel" 
                                                        name="phone" 
                                                        id="phone" 
                                                        placeholder="Phone Number"
                                                        value={formData.phone}
                                                        onChange={handleChange}
                                                        className={errors.phone ? 'error' : ''}
                                                        maxLength="10"
                                                        disabled={isSubmitting}
                                                    />
                                                    {errors.phone && (
                                                        <span className="error-message text-danger small d-block mt-1">
                                                            {errors.phone}
                                                        </span>
                                                    )}
                                                </fieldset>
                                            </fieldset>
                                        </div>

                                        {/* Password Field */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <input 
                                                        type={showPassword ? "text" : "password"}
                                                        name="password" 
                                                        id="password" 
                                                        placeholder="Password"
                                                        value={formData.password}
                                                        onChange={handleChange}
                                                        className={errors.password ? 'error' : ''}
                                                         disabled={isSubmitting}
                                                    />
                                                    <i 
                                                        className={`toggle-password fa-regular ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                                        onClick={togglePassword}
                                                        style={{ cursor: 'pointer' }}
                                                    ></i>
                                                    {errors.password && (
                                                        <span className="error-message text-danger small d-block mt-1">
                                                            {errors.password}
                                                        </span>
                                                    )}
                                                </fieldset>
                                            </fieldset>
                                        </div>

                                        {/* Confirm Password Field */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <input 
                                                        type={showConfirmPassword ? "text" : "password"}
                                                        name="confirmPassword" 
                                                        id="confirmPassword" 
                                                        placeholder="Confirm Password"
                                                        value={formData.confirmPassword}
                                                        onChange={handleChange}
                                                        className={errors.confirmPassword ? 'error' : ''}
                                                        disabled={isSubmitting}
                                                    />
                                                    <i 
                                                        className={`toggle-confrim-password fa-regular ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                                        onClick={toggleConfirmPassword}
                                                        style={{ cursor: 'pointer' }}
                                                    ></i>
                                                    {errors.confirmPassword && (
                                                        <span className="error-message text-danger small d-block mt-1">
                                                            {errors.confirmPassword}
                                                        </span>
                                                    )}
                                                </fieldset>
                                            </fieldset>
                                        </div>

                                        {/* Submit Error */}
                                        {errors.submit && (
                                            <div className="alert alert-danger mb-37" role="alert">
                                                {errors.submit}
                                            </div>
                                        )}

                                        {/* Submit Button */}
                                        <button 
                                            type="submit"
                                            className="tf-btn style-bg-primary w-full justify-content-center mb-5"
                                            disabled={isSubmitting}
                                        >
                                            <span>{isSubmitting ? 'Creating Account...' : 'Continue'}</span>
                                            <i className="icon-arrow-right"></i>
                                        </button>

                                        {/* Separator */}
                                        <div className="separator"></div>

                                        {/* Login Link */}
                                        <div className="text-center">  
                                            <label className="text-separator">Already have an Account?</label>                         
                                        </div>
                                        <Link to="/login" className="tf-btn style-border w-full justify-content-center">
                                            <span>Login</span>
                                            <i className="icon-arrow-right"></i>
                                        </Link>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer />
        </div>
    );
};
export default Register;